<!-- page starts-->
<section class="page-wrapper termsconditions-page">
    <div class="ashton-hero-top-news-single-section cf" Style="background-image: url(../assets/images/bg9img.png);">
        <div class="container">
            <div class="ashton-hero-termscondition-detail">
                <div class="ashton-hero-termscondition-detail-inner">
                    <h2>Lorem ipsum is commonly used in the print and publishing industries </h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
                    <div class="termscondition-top-btn">
                        <a href="#">Enter Now</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="termscondition-bottom-section cf">
        <div class="container">
            <div class="termscondition-bottom-detail">
                <div class="termscondition-bottom-content">
                    <div  class="red-titel">Terms And Conditions</div>
                    <div class="termscondition-bottom-content-inner">
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p>
                        <p>t is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. </p>
                        <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet.</p>
                    </div>
                </div>
                <div class="termscondition-bottom-result">
                    <div  class="red-titel">Results</div>
                    <div class="termscondition-bottom-result-main">
                        <div class="termscondition-bottom-result-inner">
                            <div class="termscondition-result-box">
                                <a href="#">
                                    <div class="termscondition-result-box-top">
                                        <div class="termscondition-result-box-top-left">
                                            <img src="assets/images/bronzz_winner.png">
                                        </div>
                                        <div class="termscondition-result-box-top-right">
                                            <h3>Lorem Ipsum</h3>
                                        </div>
                                    </div>
                                    <div class="termscondition-result-box-bottom">
                                        <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. </p>
                                    </div>
                                </a>
                            </div>
                            <div class="termscondition-result-box">
                                <a href="#">
                                    <div class="termscondition-result-box-top">
                                        <div class="termscondition-result-box-top-left">
                                            <img src="assets/images/bronzz_winner.png">
                                        </div>
                                        <div class="termscondition-result-box-top-right">
                                            <h3>Lorem Ipsum</h3>
                                        </div>
                                    </div>
                                    <div class="termscondition-result-box-bottom">
                                        <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. </p>
                                    </div>
                                </a>
                            </div>
                            <div class="termscondition-result-box">
                                <a href="#">
                                    <div class="termscondition-result-box-top">
                                        <div class="termscondition-result-box-top-left">
                                            <img src="assets/images/bronzz_winner.png">
                                        </div>
                                        <div class="termscondition-result-box-top-right">
                                            <h3>Lorem Ipsum</h3>
                                        </div>
                                    </div>
                                    <div class="termscondition-result-box-bottom">
                                        <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. </p>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section><!-- page ends-->